import React from "react";

// Shows the completion percentage (Sections 2–5 @ 25% each) on every step. Once
// the application is submitted the number is replaced with a "Submitted" badge,
// and after the sponsor is confirmed it reads "Finalized."
export function CompletionIndicator({
  completionPercent,
  status,
}: {
  completionPercent: number;
  status: "InProgress" | "Submitted" | "Finalized" | string;
}) {
  if (status === "Finalized") {
    return (
      <div className="mb-3">
        <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-800">
          &#10003; Finalized
        </span>
      </div>
    );
  }

  if (status === "Withdrawn") {
    return (
      <div className="mb-3">
        <span className="inline-flex items-center rounded-full bg-slate-200 px-3 py-1 text-sm font-medium text-slate-700">
          Withdrawn
        </span>
      </div>
    );
  }

  if (status === "Submitted") {
    return (
      <div className="mb-3">
        <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-800">
          &#10003; Submitted
        </span>
      </div>
    );
  }

  const percent = Math.max(0, Math.min(100, Math.round(completionPercent)));

  return (
    <div className="mb-3">
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200">
        <div className="h-full bg-program transition-all" style={{ width: `${percent}%` }} />
      </div>
      <p className="mt-1 text-right text-xs text-slate-500">{percent}% Complete</p>
    </div>
  );
}
